<template>
	<textarea
		:class="props.inputClass"
		:name="props.name"
		:placeholder="props.placeholder"
		:value="modelValue"
		@input="changeInput($event.target.value)"
	></textarea>
</template>

<script setup>

const props = defineProps({
    type: {
			type: String,
			default: 'text'
    },
    inputClass: {
			type: String,
			default: 'textarea'
    },
    placeholder: {
			type: String,
			default: ''
    },
    name: {
			type: String,
			default: ''
    },
    modelValue: {
			type: [String, Number],
			default: ''
    }
})

const emit = defineEmits(['update:modelValue'])
const changeInput = (value) => {
  emit('update:modelValue', value);
}

</script>  